import { useState } from 'react';
import { AuthenticatorType } from '@mews-commander/data-access';
import { LinkButton, RoutePaths } from '@mews-commander/ui';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Stack } from '@optimus-web/core';
import { TwoFactorAuthenticationSelectionCardGroup } from '../../components/TwoFactorAuthenticationSelectionCardGroup';
import { Configure2FALayout } from './Configure2FALayout';

const routeMap = {
    [AuthenticatorType.Google]: '/Home/Configure2FA/Device',
    [AuthenticatorType.Email]: '/Home/Configure2FA/Email',
    [AuthenticatorType.None]: '/Home/Configure2FA/Device',
} as const satisfies Record<AuthenticatorType, RoutePaths>;

export function Configure2FA() {
    const [selected2FAMode, setSelected2FAMode] = useState(AuthenticatorType.Google);

    return (
        <Configure2FALayout
            title={TextKey.EnableTwoFactorAuthentication}
            subtitle={TextKey.EnableTwoFactorAuthenticationDescription}
        >
            <Stack spacing="300" vertical>
                <TwoFactorAuthenticationSelectionCardGroup inputValue={selected2FAMode} onChange={setSelected2FAMode} />
                <Stack alignment="end">
                    <LinkButton to={routeMap[selected2FAMode]} variant="primary" size="medium">
                        <LocalizedText textKey={TextKey.Next} />
                    </LinkButton>
                </Stack>
            </Stack>
        </Configure2FALayout>
    );
}
